/**
 * Configurator quick view: the title or picture of a material/accessory card opens a dialog with the
 * product (sections/configurator-quick-view.liquid, fetched with the Section Rendering API). The card's
 * variant is shown, not changed.
 */
const SECTION_ID = 'configurator-quick-view';

/** Slider: scroll-snap track, the shown slide is read from the scroll position. */
function initGallery(gallery) {
  const track = gallery.querySelector('.configurator-quick-view__track');
  const thumbs = gallery.querySelectorAll('.configurator-quick-view__thumb');
  const prev = gallery.querySelector('.configurator-quick-view__arrow--prev');
  const next = gallery.querySelector('.configurator-quick-view__arrow--next');
  const counter = gallery.querySelector('.configurator-quick-view__counter');
  const total = track.children.length;
  let shown = -1;

  const goTo = (index, behavior) => track.scrollTo({ left: index * track.clientWidth, behavior });

  function update() {
    const index = Math.round(track.scrollLeft / track.clientWidth);
    if (index === shown) return;
    shown = index;

    if (counter) counter.textContent = `${index + 1} / ${total}`;
    if (prev) prev.disabled = index === 0;
    if (next) next.disabled = index === total - 1;
    thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', i === index));
    if (thumbs[index]) thumbs[index].scrollIntoView({ block: 'nearest', inline: 'center' });
  }

  track.addEventListener('scroll', update, { passive: true });
  if (prev) prev.addEventListener('click', () => goTo(shown - 1));
  if (next) next.addEventListener('click', () => goTo(shown + 1));
  thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => goTo(index)));

  goTo(Number(gallery.dataset.startIndex) || 0, 'instant');
  update();
}

function setup(dialog) {
  const block = dialog.closest('block-configurator');
  const body = dialog.querySelector('.configurator-quick-view__body');
  const errorLink = dialog.querySelector('.configurator-quick-view__status a');
  const cache = new Map();
  let controller;

  async function load(url) {
    if (!cache.has(url)) {
      const response = await fetch(url, { signal: controller.signal });
      if (!response.ok) throw new Error(response.status);
      cache.set(url, await response.text());
    }
    return cache.get(url);
  }

  async function open(productUrl, variantId) {
    const url = new URL(productUrl);
    url.searchParams.set('section_id', SECTION_ID);
    url.searchParams.set('variant', variantId);

    controller = new AbortController();
    errorLink.href = productUrl;
    dialog.dataset.state = 'loading';
    document.body.style.overflow = 'hidden';
    dialog.showModal();

    try {
      const template = document.createElement('template');
      template.innerHTML = await load(url.href);
      body.replaceChildren(template.content);
      dialog.dataset.state = 'ready';

      // The first two accordions come open (mobile); desktop starts with all closed
      if (window.matchMedia('(min-width: 750px)').matches) {
        body.querySelectorAll('details').forEach((details) => {
          details.open = false;
        });
      }

      const gallery = body.querySelector('.configurator-quick-view__gallery');
      if (gallery) initGallery(gallery);
    } catch (error) {
      if (error.name !== 'AbortError') dialog.dataset.state = 'error';
    }
  }

  // The cards are in the same block. Ctrl/cmd/shift clicks on the title keep opening the product page.
  block.addEventListener('click', (event) => {
    const card = event.target.closest('[data-quick-view]');
    const trigger =
      card &&
      event.target.closest('.configurator-card-item__title, .configurator-card-item__image');
    if (!trigger || event.metaKey || event.ctrlKey || event.shiftKey) return;

    event.preventDefault();
    const checkbox = card.querySelector('[data-configurator-checkbox]');
    open(card.querySelector('.configurator-card-item__title').href, checkbox.value);
  });

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });
  dialog
    .querySelector('.configurator-quick-view__close')
    .addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => {
    controller.abort();
    body.replaceChildren();
    document.body.style.overflow = '';
  });
}

document.querySelectorAll('.configurator-quick-view').forEach(setup);
